import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var SquareFeetSVG = function SquareFeetSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M29.39,25.56l-24-22A1.9767,1.9767,0,0,0,4.01,3H4A2.0048,2.0048,0,0,0,2,5V28a1.0029,1.0029,0,0,0,1,1H28a1.9917,1.9917,0,0,0,2-2A1.9163,1.9163,0,0,0,29.39,25.56ZM8,26.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V25a1,1,0,0,1,2,0Zm5,0a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V25a1,1,0,0,1,2,0ZM10,21V16l5,5Zm8,5.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V25a1,1,0,0,1,2,0Zm5,0a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V25a1,1,0,0,1,2,0Z"
  }));
};
SquareFeetSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(SquareFeetSVG);